import React from 'react';
import styled from 'styled-components';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import MuiDialogContent from '@mui/material/DialogContent';
import classNames from 'classnames';

import { isMobile } from 'react-device-detect';

import IconButton from 'SharedComponents/icon-button';
import FormLinkBankAccount from 'SharedComponents/form-link-bank-account';

import logoSmall from 'Images/logo-400px-BoostYourSuper.png';

import styles from './index.css';

const ModalDialogV3Wrapper = styled(Dialog)`
  ${styles}
`;

const ModalDialogV3 = ({
  open,
  onCloseModalDialogV3,
  titleComponent,
  titleComponentOverideStyles,
  explainerComponent,
  explainerComponentOverideStyles,
  contentComponent,
  errorMessage,
}) => {
  console.log('ModalDialogV3 has been triggered');
  const windowWidth = window.innerWidth;
  return (
    <ModalDialogV3Wrapper 
      open={open} 
      fullScreen={windowWidth < 768}
    >
    <div className="content-container">
      <div className="modal-header">
        <div className='logo-container'>
          <img className='img' src={logoSmall} alt="logo1" />
        </div>
        <div className="close-dialog-container">
          <IconButton className={"close-dialog"} onClick={onCloseModalDialogV3}>
            <i className="material-icons">close</i>
          </IconButton>
        </div>
      </div>
      {
        titleComponent && (
          <div className="title-component" style={titleComponentOverideStyles}>
              {titleComponent}
          </div>
        )
      }
        <div className="error-message">
          <text> &nbsp; {errorMessage}</text>
        </div>
      {
        explainerComponent && (
          <div className="explainer-component" style={explainerComponentOverideStyles}>
              {explainerComponent}
          </div>
        )
      }
      { contentComponent && (
          <div className="content-component">
            {contentComponent}
          </div>
        )
      }
      
    </div>
    </ModalDialogV3Wrapper>
  );
};

export default ModalDialogV3;
